module.exports = __webpack_public_path__ + "themes/mf/img/prize-2.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/prize-2.png
// module id = 88
// module chunks = 3